module.exports = "pegasus/assets/themelp1/launch/202.png";